// extracted by mini-css-extract-plugin
export default {"signUpScreen":"SignUp_signUpScreen__ALxmE","signUpBox":"SignUp_signUpBox__8calL","closeIcon":"SignUp_closeIcon__DwJd-","goToLogin":"SignUp_goToLogin__QXNEm"};